import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  query GetShortedOrders($pickDate: String, $waveIds: [Int!]) {
    shortedOrders(pickDate: $pickDate, waveIds: $waveIds) {
      ...OrderRow
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/getShortedOrders.js